import { Component, inject, OnInit } from '@angular/core';
import { JeevesInvoiceActionConfigService, JeevesInvoiceCardListComponent } from 'gung-standard-jeeves';
import { CustomerService } from 'gung-standard';
import { first } from 'rxjs';
import { HlDisplayDateUtilService } from '../../services/hl-display-date-util.service';
import { HlDisplayPortalFeaturesService, PriceSettingsGroup } from '../../services/hl-display-portal-features.service';

@Component({
  selector: 'app-hl-display-invoice-card-list',
  templateUrl: './hl-display-invoice-card-list.component.html',
  styleUrls: ['./hl-display-invoice-card-list.component.css'],
  standalone: false
})
export class HlDisplayInvoiceCardListComponent extends JeevesInvoiceCardListComponent implements OnInit {
  public configService = inject(JeevesInvoiceActionConfigService);
  protected costumerService = inject(CustomerService);
  protected dateUtilService = inject(HlDisplayDateUtilService);
  protected hlDisplayPortalFeaturesService = inject(HlDisplayPortalFeaturesService);

  protected hidePrices: boolean = false;

  ngOnInit(): void {
    this.hlDisplayPortalFeaturesService
      .getPortalFeatureGroup('priceSettingsGroup')
      .pipe(first())
      .subscribe(priceSettingsGroup => {
        this.hidePrices = (priceSettingsGroup as PriceSettingsGroup)?.hidePrices;
      });
  }
}
